(function () {
  window.dataLayer = window.dataLayer || [];
  window.sendGTMData = (data) => {
    try {
      if (!data) {
        console.error('Send GTM data Error: No data to send');
        return;
      }

      if (!data.event) {
        console.error('event param is missing');
        return;
      }

      if (!data.theme_id) data.theme_id = window.Shopify.theme.id;
      if (!data.theme_name) data.theme_name = window.Shopify.theme.name;
      if (!data.environment) data.environment = window.Shopify.shop.includes('trythirdlove') ? 'UAT' : 'PROD';
      if (!data.user_locale && window.userLocale) data.user_locale = window.userLocale;
      if (!data.country) data.country = window.Shopify.country;
      if (!data.currency) data.currency = window.Shopify.currency.active;
      if (!data.customer_id && window.theme.customer?.id) data.customer_id = window.theme.customer.id;
      if (!data.customer_email && window.theme.customer?.email && window.browserCrypto) {
        const cipherInstance = window.browserCrypto.createCipher(
          'aes-256-cbc',
          'e72bf1be-5692-4162-a9d8-d355450c2374',
        );
        const encryptedEmail = cipherInstance.update(window.theme.customer.email, 'utf8', 'hex');
        const finalEmailHash = encryptedEmail + cipherInstance.final('hex');
        data.customer_email = finalEmailHash;
      }

      Object.keys(data).forEach(key => data[key] === undefined && delete data[key]);

      window.dataLayer.push(data);
    } catch(err) {
      console.error(err);
    }
  }
})()
